import { render, staticRenderFns } from "./BsGridColumnFilters.vue?vue&type=template&id=1003870c&"
import script from "./BsGridColumnFilters.vue?vue&type=script&lang=js&"
export * from "./BsGridColumnFilters.vue?vue&type=script&lang=js&"
import style0 from "./BsGridColumnFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports